module.exports = __webpack_public_path__ + "static/maiaflash-a2289a04b6a910c08d120fe2d3954cfb.png";